class ErrorMessageController {
  constructor(
    $sce,
    LanguageService,
    LogService,
    DEBUG
  ) {
    "ngInject";
    this.$sce = $sce;
    this.LanguageService = LanguageService;
    this.LogService = LogService;
    this.DEBUG = DEBUG;
  }

  set error(error) {
    this._error = error;
  }

  get error() {
    return this._error;
  }

  get errorText() {
    return this.$sce.trustAsHtml(this.error && this.error.message || this.error);
  }

  get errorKey() {
    return this.error && this.error.key;
  }

  get errorValues() {
    return this.error && this.error.values;
  }

  get useTranslation() {
    return !!this.errorKey;
  }
}

export default ErrorMessageController;
